// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"#f3f3f3","white":"#fff","grayNote":"#a2a2a2"};